var chunkMapping = {
	"70": [
		3070
	],
	"343": [
		7343
	],
	"477": [
		6477
	],
	"509": [
		3509
	],
	"623": [
		4623
	],
	"754": [
		9754
	],
	"786": [
		5786
	],
	"843": [
		330,
		421,
		5271,
		5534,
		5711,
		6435
	]
};
var idToExternalAndNameMapping = {
	"330": [
		"default",
		"./generic/components/general/toast",
		1305
	],
	"421": [
		"default",
		"./generic/helpers/google-tag-manager",
		1305
	],
	"3070": [
		"default",
		"./generic/components/general/sheet",
		1305
	],
	"3509": [
		"default",
		"./generic/components/lists/category-list",
		1305
	],
	"4623": [
		"default",
		"./generic/components/navigation/breadcrumbs",
		1305
	],
	"5271": [
		"default",
		"./generic/elements/icons",
		1305
	],
	"5534": [
		"default",
		"./generic/elements/menu-item",
		1305
	],
	"5711": [
		"default",
		"./generic/elements/info-block",
		1305
	],
	"5786": [
		"default",
		"./mancity/components/general/seo",
		1305
	],
	"6435": [
		"default",
		"./generic/components/profile/avatar",
		1305
	],
	"6477": [
		"default",
		"./mancity/components/headers/search-header",
		1305
	],
	"7343": [
		"default",
		"./generic/elements/button",
		1305
	],
	"9754": [
		"default",
		"./mancity/template/freeform",
		1305
	]
};
var idToRemoteMap = {
	"330": [
		{
			"externalType": "script",
			"name": "core"
		}
	],
	"421": [
		{
			"externalType": "script",
			"name": "core"
		}
	],
	"3070": [
		{
			"externalType": "script",
			"name": "core"
		}
	],
	"3509": [
		{
			"externalType": "script",
			"name": "core"
		}
	],
	"4623": [
		{
			"externalType": "script",
			"name": "core"
		}
	],
	"5271": [
		{
			"externalType": "script",
			"name": "core"
		}
	],
	"5534": [
		{
			"externalType": "script",
			"name": "core"
		}
	],
	"5711": [
		{
			"externalType": "script",
			"name": "core"
		}
	],
	"5786": [
		{
			"externalType": "script",
			"name": "core"
		}
	],
	"6435": [
		{
			"externalType": "script",
			"name": "core"
		}
	],
	"6477": [
		{
			"externalType": "script",
			"name": "core"
		}
	],
	"7343": [
		{
			"externalType": "script",
			"name": "core"
		}
	],
	"9754": [
		{
			"externalType": "script",
			"name": "core"
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes.chunkMapping = chunkMapping;
__webpack_require__.federation.bundlerRuntimeOptions.remotes.idToExternalAndNameMapping = idToExternalAndNameMapping;
__webpack_require__.federation.bundlerRuntimeOptions.remotes.idToRemoteMap = idToRemoteMap;
__webpack_require__.remotesLoadingData.moduleIdToRemoteDataMapping = {
	"330": {
		"shareScope": "default",
		"name": "./generic/components/general/toast",
		"externalModuleId": 1305,
		"remoteName": "core"
	},
	"421": {
		"shareScope": "default",
		"name": "./generic/helpers/google-tag-manager",
		"externalModuleId": 1305,
		"remoteName": "core"
	},
	"3070": {
		"shareScope": "default",
		"name": "./generic/components/general/sheet",
		"externalModuleId": 1305,
		"remoteName": "core"
	},
	"3509": {
		"shareScope": "default",
		"name": "./generic/components/lists/category-list",
		"externalModuleId": 1305,
		"remoteName": "core"
	},
	"4623": {
		"shareScope": "default",
		"name": "./generic/components/navigation/breadcrumbs",
		"externalModuleId": 1305,
		"remoteName": "core"
	},
	"5271": {
		"shareScope": "default",
		"name": "./generic/elements/icons",
		"externalModuleId": 1305,
		"remoteName": "core"
	},
	"5534": {
		"shareScope": "default",
		"name": "./generic/elements/menu-item",
		"externalModuleId": 1305,
		"remoteName": "core"
	},
	"5711": {
		"shareScope": "default",
		"name": "./generic/elements/info-block",
		"externalModuleId": 1305,
		"remoteName": "core"
	},
	"5786": {
		"shareScope": "default",
		"name": "./mancity/components/general/seo",
		"externalModuleId": 1305,
		"remoteName": "core"
	},
	"6435": {
		"shareScope": "default",
		"name": "./generic/components/profile/avatar",
		"externalModuleId": 1305,
		"remoteName": "core"
	},
	"6477": {
		"shareScope": "default",
		"name": "./mancity/components/headers/search-header",
		"externalModuleId": 1305,
		"remoteName": "core"
	},
	"7343": {
		"shareScope": "default",
		"name": "./generic/elements/button",
		"externalModuleId": 1305,
		"remoteName": "core"
	},
	"9754": {
		"shareScope": "default",
		"name": "./mancity/template/freeform",
		"externalModuleId": 1305,
		"remoteName": "core"
	}
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}